import React from 'react'
import PropTypes from 'prop-types'
import TeamEditContainer from './TeamEditContainer'

const TeamEdit = ({ match, history }) => (
  <TeamEditContainer match={match} history={history} />
)

TeamEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      teamId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
}

export default TeamEdit
